var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCommission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_commission") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_commission",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-24px",
    transform: "translate(0.000000, 3.000000)",
    fill: "#005082"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,5.22222222 L14,5.22222222 L14,8.05555556 L11,8.05555556 L11,9.94444444 L14,9.94444444 L14,12.7777778 L16,12.7777778 L16,9.94444444 L19,9.94444444 L19,8.05555556 L16,8.05555556 L16,5.22222222 Z M2,9 C2,6.365 3.64,4.08888889 6.01,3.03111111 L6.01,0.991111111 C2.52,2.16222222 0,5.30722222 0,9 C0,12.6927778 2.52,15.8377778 6.01,17.0088889 L6.01,14.9688889 C3.64,13.9111111 2,11.635 2,9 L2,9 Z M15,0.5 C10.04,0.5 6,4.31555556 6,9 C6,13.6844444 10.04,17.5 15,17.5 C19.96,17.5 24,13.6844444 24,9 C24,4.31555556 19.96,0.5 15,0.5 L15,0.5 Z M15,15.6111111 C11.14,15.6111111 8,12.6455556 8,9 C8,5.35444444 11.14,2.38888889 15,2.38888889 C18.86,2.38888889 22,5.35444444 22,9 C22,12.6455556 18.86,15.6111111 15,15.6111111 L15,15.6111111 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommission);
export default __webpack_public_path__ + "static/media/icon_commission.ed8aa68d56f668ae04e148db947e74cc.svg";
export { ForwardRef as ReactComponent };